import React, { MouseEvent } from 'react'
import styled from 'styled-components'
import { renderSvg } from '@utils/genUtils'

interface IProps {
  text: string
  outlineColor?: string
  outlineHoverColor?: string
  clickHandler: () => void
  size?: string
  outline?: boolean
  icon?: string
}

function ThemeButton ({
                        icon,
                        size = 'regular',
                        outline = false,
                        outlineColor = '#fff',
                        outlineHoverColor = '#fff',
                        clickHandler,
                        text,
                      }: IProps) {
  function click (e: MouseEvent) {
    e.preventDefault()
    clickHandler()
  }

  return (
    <StyledButton
      onClick={click}
      outline={outline}
      outlineColor={outlineColor}
      outlineHoverColor={outlineHoverColor}
    >
      {icon && <Icon>{renderSvg(icon)}</Icon>}
      {text}
    </StyledButton>
  )
}

interface IButtonProps {
  outline: boolean
  outlineColor: string
  outlineHoverColor: string
}

const StyledButton = styled.button<IButtonProps>`
  color: ${props => props.outline ? props.outlineColor : props.theme.buttonPrimary.textColor};
  background: ${props => props.outline ? 'transparent' : props.theme.buttonPrimary.color};
  border: ${props => props.outline ? `3px solid ${props.outlineColor}` : 'none'};
  border-radius: 50px;
  padding: 8px 40px;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 500;
  transition: .3s;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover{
    cursor: pointer;
    color: ${props => props.outline ? props.outlineHoverColor : props.theme.buttonPrimary.textHoverColor};
    background: ${props => props.theme.buttonPrimary.backgroundHoverColor};
    border-color: ${props => props.outline ? props.theme.buttonPrimary.backgroundHoverColor : ''};
    svg{
      path{
        fill: ${props => props.outline ? props.outlineHoverColor : props.theme.buttonPrimary.textHoverColor};
      }
    } 
  }
  &:focus{
    outline: none;
  }
  
  svg{
    width: 100%;
    path{
      transition: .3s;
      fill: ${props => props.outline ? props.outlineColor : props.theme.buttonPrimary.textColor};
    }
  } 
`
const Icon = styled.span`
  position: relative;
  width: 25px;
  height: 25px;
  margin-right: 10px;
`
export default ThemeButton
